export default 'M4 3a3 3 0 0 1 3-3 3 3 0 0 1 3 3v18a3 3 0 0 1-3 3 3 3 0 0 1-3-3zm10 0a3 3 0 0 1 3-3 3 3 0 0 1 3 3v18a3 3 0 0 1-3 3 3 3 0 0 1-3-3z';